export const DEBOUNCE_DELAY = 1000

export const INFO_SEPARATOR = '##'

export const HASH_DELIMITER = '@@'

export const TREE_ITEM_FOUND_CLASS = 'ui-tree__item--found'
export const TREE_ITEM_HIGHLIGHTED_CLASS = 'ui-tree__item--highlighted'
export const TREE_LAZY_CLASS = 'ui-tree__lazy'

export const TREE_LAZY_COUNT = 100

export const DEGRADED_SEARCH_THRESHOLD = 500
